export default __webpack_public_path__ + "static/media/formLevelWarningsMenuIcon.453983b0.svg";